import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Angulartics2AppInsights} from 'angulartics2/appinsights';
import {
    map,
    switchMap
} from 'rxjs/operators';
import {
    from,
    Observable,
    Subject
} from 'rxjs';

// Classes
import {
    CasePagination,
    User
} from '../classes/user';
import {TokenResponse} from '../classes/tokenResponse';
import {CaseFilter} from '../classes/CaseFilter';
import {NpsRating} from '../classes/NpsRating';
import {Dictionary} from '../classes/Dictionary';
import {Product} from '../classes/Product';

// Services
import {RestCaseService} from './restService/restCaseService';
import {RestCasesService} from './restService/restCasesService';
import {BaseRestService} from './restService/baseRestService';
import {LoggingService} from '../shared/abstraction/LoggingService';

import {environment} from 'src/environments/environment';
import {AccountAddress} from "../authorise/models/accountaddress";
import {RestProductsService} from "./restService/restProductsService";
import {RestUsersService} from "./restService/restUsersService";
import {RestUserService} from "./restService/restUserService";

@Injectable({
    providedIn: 'root'
})

export class DataService extends BaseRestService {
    constructor(private http: HttpClient,
                private _angulartics: Angulartics2AppInsights,
                private _logger: LoggingService,
                private restCaseService: RestCaseService,
                private restUsersService: RestUsersService,
                private restUserService: RestUserService,
                private restCasesService: RestCasesService,
                private restProductService: RestProductsService
    ) {
        super();
        this.user = undefined;
    }

    user: User;
    companyname: string;
    loading: boolean;
    accountId: string;
    private isAddToExistingCase: boolean;

    private isUserLoggedIn = new Subject<string>();
    loggedIn = this.isUserLoggedIn.asObservable();
    statusData: string | number[];


    activeUsers: Dictionary[] = [];

    changeLoggedInUserAtAppLevel(res: string) {
        this.isUserLoggedIn.next(res);
    }

    IsAddToExisting(addToExistingCase: boolean) {
        this.isAddToExistingCase = addToExistingCase;
    }

    ExtendToken() {
        setInterval(() => {
            const restApiToken = localStorage.getItem('restApiToken');
            if (restApiToken) {
                return this.restUserService.ExtendToken(restApiToken).subscribe(res => {
                    if (res) {
                        this._logger.Log('TokenGotExtended', {success: true, token: restApiToken});
                    }
                });
            }
        }, 60000);
    }

    GetAddToExistingCase() {
        return this.isAddToExistingCase;
    }
    

    GetBondProduct(): Observable<Product[]> {
        return this.restProductService.getBasicProduct([400]);
    }

    GetAccountAddress(): Observable<AccountAddress> {
        return this.restUsersService.getAccountAddress();
    }
    
    public getAllCasesByFilter(caseFilter: CaseFilter, filterType: string): Observable<CasePagination> {
        return from(this.restUsersService.getAccountDetails()).pipe(
            switchMap((_) => {
                if (!caseFilter.pageNumber) {
                    if (caseFilter.orderstatuses && caseFilter.orderstatuses.length === 0) {
                        this.statusData = [];
                    } else if (caseFilter.orderstatuses && caseFilter.orderstatuses.length > 1) {
                        this.statusData = '[' + caseFilter.orderstatuses.join(',') + ']';
                    } else {
                        this.statusData = caseFilter.orderstatuses;
                    }
                }

                caseFilter.accountid = parseInt(localStorage.getItem('accountid'), 10);

                const accountUserId = caseFilter.accountuserid ?? localStorage.getItem('userid');
                const filter = filterType === 'all' ? '0' : accountUserId.toString();

                return this.restCasesService.getCasesByFilter(caseFilter, caseFilter.orderstatuses, filter);
            })
        );
    }

    public GetAccountByUsername(accountId: number, username: string): Observable<User> {
        return this.restUsersService.getAccountByUsername(accountId, username);
    }

    public GetAccountFcaStatus(): Observable<boolean> {
        return this.restUsersService.getAccountFcaStatus();
    }

    public GetAccountUserDetails(userId: number): Observable<User> {
        return this.restUsersService.getAccountUserDetails(userId);
    }

    public SendNpsRating(request: NpsRating) {
        return this.http.post(environment.restApiUrl + '/NpsRating', request, {headers: this.authHeadersV2});
    }

    public GetCaseType(productType: number): Observable<number> {
        return this.restCaseService.getCaseType(productType);
    }
}
